import { render, staticRenderFns } from "./DetallePlanSuccess.vue?vue&type=template&id=246df1d9&scoped=true&"
import script from "./DetallePlanSuccess.vue?vue&type=script&lang=js&"
export * from "./DetallePlanSuccess.vue?vue&type=script&lang=js&"
import style0 from "./DetallePlanSuccess.vue?vue&type=style&index=0&id=246df1d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246df1d9",
  null
  
)

export default component.exports